// Standard pagination shape for every list endpoint in the cortex API.
// Lives here (not under apps/api) so the frontend imports the same
// contract from `@cortex/types` and never drifts from the backend.
// (DEV-16158.)
//
// The shape is intentionally one wrapper for everything: traditional
// offset+limit consumers read `offset` + `limit` + `total`; infinite-
// scroll consumers read `hasMore` and keep advancing `offset` by
// `items.length` until it flips false. We don't yet ship a cursor
// variant — at cortex's scale OFFSET is fine, and the wire shape
// stays one type instead of a discriminated union.
import { z } from 'zod';
/**
 * Zod factory: pass the per-item schema, get back a Zod schema for
 * `IPaginated<T>`. Use this when validating an inbound API response,
 * or when authoring an OpenAPI spec via `nestjs-zod` / `createZodDto`.
 *
 *   const WorkflowListResponse = paginatedSchema(WorkflowListItemSchema);
 *   type WorkflowListResponse = z.infer<typeof WorkflowListResponse>;
 */
export function paginatedSchema(itemSchema) {
    return z.object({
        items: z.array(itemSchema),
        total: z.number().int().nonnegative(),
        limit: z.number().int().positive(),
        offset: z.number().int().nonnegative(),
        hasMore: z.boolean(),
    });
}
//# sourceMappingURL=pagination.js.map